import { uncapitalize } from '@attain-apps/string-utils'

import * as core from '../../../../../../core'
import * as common from '../../../../../common'

import * as jobType from './job-type'

// NOTE: everything below is designed to simulate a normal folder/module
// structure for exporting resources from separate files. This just simply
// generates those resources based on the known enum entries

const enumId = core.dms.models.Enum.Id.from({
  partialId: jobType.RESOURCE.payload.partialId,
})

const enumEntryResourceNameLookup = {} as Record<common.JobType, string>
for (const enumEntryName in common.JobType) {
  const potentialEnum =
    common.JobType[enumEntryName as keyof typeof common.JobType]
  if (common.JobType.isJobType(potentialEnum)) {
    enumEntryResourceNameLookup[potentialEnum] = uncapitalize(enumEntryName)
  }
}

export const entries = common.JobType.ALL.reduce(
  (prev, _jobType) =>
    Object.assign(prev, {
      [enumEntryResourceNameLookup[_jobType]]: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        RESOURCE: {
          payload: {
            ...common.JobType.getEntry(_jobType),
            enumId,
          },
          type: core.quiver.Resource.Type.DmsEnumEntry,
        } as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>,
      },
    }),
  {} as {
    [K in keyof typeof common.JobType as (typeof common.JobType)[K] extends common.JobType
      ? Uncapitalize<K>
      : never]: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      RESOURCE: core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
    }
  },
)
